(() => {
  const bfInThemeEditor = () => {
    try {
      return !!(window.Shopify && window.Shopify.designMode) || (window.self !== window.top && /admin\.shopify\.com/.test(document.referrer));
    } catch (e) {
      return false;
    }
  };
  if (bfInThemeEditor()) return;
  const titles = {
    '/collections/alle-produkte-1': ['Alle Produkte', 'Natürliche Pflege aus dem Schwarzwald'],
    '/collections/naturpflegeprodukte': ['Naturpflegeprodukte', 'Pflege für Bart, Haut und Haar'],
    '/collections/bestseller': ['Bestseller', 'Unsere beliebtesten Produkte'],
    '/collections/t-shirts-caps': ['T-Shirts & Caps', 'Black Forest Co. Kleidung und Caps']
  };
  const text = el => (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  const setText = (el, value) => { if (el && value && text(el) !== value) el.textContent = value; };
  function earlyFix() {
    const header = document.querySelector('header,.header,#shopify-section-header');
    if (header) {
      header.querySelectorAll('a,button').forEach(el => {
        const label = text(el);
        const href = el.getAttribute && (el.getAttribute('href') || '');
        if (/^FAQ/i.test(label) || href.includes('/pages/faqs')) {
          const item = el.closest('li,details,.menu-list__item,.header__menu-item,.x-menu-link,.nav-item,.list-menu__item') || el;
          item.style.display = 'none';
        }
        if (label === 'Philosophy') el.textContent = 'Philosophie';
        if (el.matches && el.matches('a.tree-menu-item') && (label === 'Shop' || label === 'Produkte' || href.includes('/collections/alle-produkte-1'))) {
          el.textContent = 'Produkte';
          el.setAttribute('href', '/collections/alle-produkte-1');
        }
        if (el.matches && el.matches('a.nav-link') && (label === 'Shop' || href.includes('/collections/alle-produkte-1'))) {
          el.textContent = 'Naturpflegeprodukte';
          el.setAttribute('href', '/collections/naturpflegeprodukte');
        }
      });
    }
    const data = titles[location.pathname];
    if (data) {
      document.querySelectorAll('.bf-collection-intro').forEach(el => el.remove());
      document.querySelectorAll('h1,h2').forEach(el => {
        if (/Alle Naturpflegeprodukte|Alle Produkte|Naturpflegeprodukte|Bestseller|T-Shirts|Caps/.test(text(el))) setText(el, data[0]);
      });
      document.querySelectorAll('.section-slideshow p,#shopify-section-template--25548458623243__slideshow_gP9RtF p').forEach(el => {
        if (/Natürliche Pflege aus dem Schwarzwald|Pflege für Bart|Unsere beliebtesten Produkte|Kleidung und Caps/.test(text(el))) setText(el, data[1]);
      });
    }
  }
  earlyFix();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', earlyFix, { once: true });
  [40, 120, 300, 700, 1400].forEach(delay => setTimeout(earlyFix, delay));
})();

if (!window.Eurus.loadedScript.has('dark-mode.js')) {
  window.Eurus.loadedScript.add('dark-mode.js');
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => { 
      Alpine.store('xDarkMode', {
        alias: "btn-theme-mode",
        toggleThemeMode() {
          Alpine.store('xDOM').rePainting = this.alias;
          setTimeout(() => {
            if (document.documentElement.classList.contains('dark')) {
              localStorage.eurus_theme = 0;
              document.documentElement.classList.remove('dark');
            } else {
              localStorage.eurus_theme = 1;
              document.documentElement.classList.add('dark');
            }
            Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();

            Alpine.store('xDOM').rePainting = null;
          }, 200); // INP
        },
        toggleLightMode() {
          Alpine.store('xDOM').rePainting = this.alias;
          setTimeout(() => {
            localStorage.eurus_theme = 0;
            document.documentElement.classList.remove('dark');
            Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();

            Alpine.store('xDOM').rePainting = null;
          }, 200); // INP
        },
        toggleDarkMode() {
          Alpine.store('xDOM').rePainting = this.alias;
          setTimeout(() => {
            localStorage.eurus_theme = 1;
            document.documentElement.classList.add('dark');
            Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();

            Alpine.store('xDOM').rePainting = null;
          }, 200); // INP
        }
      });
      Alpine.store('pseudoIconTheme', {
        init() {
          this.updatePseudoIconInputTheme();
        },
        updatePseudoIconInputTheme() {
          const themeMode = localStorage.getItem('eurus_theme');
          document.querySelectorAll('input[type="date"], input[type="time"]').forEach(input => {
            if (themeMode === '1') {
              input.style.colorScheme = 'dark';
            } else {
              input.removeAttribute('style');
            }
          });
        }      
      });
    })
  })
}